import { createSlice } from '@reduxjs/toolkit';

export type ImagingSchedulesState = {
  selectedImagingScheduleID: number;
  isDirty: boolean;
};

const initialState = {
  selectedImagingScheduleID: 0,
  isDirty: false,
} as ImagingSchedulesState;

const imagingSchedulesReducer = createSlice({
  name: 'ImagingSchedules',
  initialState,
  reducers: {
    setSelectedImagingScheduleID: (state, action) => {
      state.selectedImagingScheduleID = action.payload;
    },
    setImagingSchedulesIsDirty: (state, action) => {
      state.isDirty = action.payload;
    },
  },
});

export const { setSelectedImagingScheduleID, setImagingSchedulesIsDirty } =
  imagingSchedulesReducer.actions;

export default imagingSchedulesReducer.reducer;
